module.exports = __webpack_public_path__ + "static/media/Bullet-check.8a18ed51.svg";